








import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class ReloadButton extends Vue {
  public name: string = "ReloadButton";

  @Prop({required: false, default: ''})
  public buttonType!: string;

  @Prop({required: false, default: false})
  public isLoading!: string;

  private get buttonClasses(): any {
    let classesString: string = this.buttonType;

    if (this.isLoading) {
      classesString += ' is-loading';
    }

    return classesString;
  }


}
